/**
 * Common responsive grid column configurations
 * Use with CSS Grid's gridTemplateColumns property
 */
export const RESPONSIVE_GRID_COLUMNS = {
  /**
   * Standard card grid: 1 -> 2 -> 3 -> 4 columns
   */
  cards: {
    xs: '1fr',
    sm: 'repeat(2, 1fr)',
    md: 'repeat(3, 1fr)',
    lg: 'repeat(4, 1fr)',
  },
  /**
   * Wide card grid: 1 -> 2 -> 2 -> 3 columns
   */
  wideCards: {
    xs: '1fr',
    sm: 'repeat(2, 1fr)',
    md: 'repeat(2, 1fr)',
    lg: 'repeat(3, 1fr)',
  },
  /**
   * Two column layout
   */
  twoColumn: {
    xs: '1fr',
    sm: 'repeat(2, 1fr)',
  },
} as const;

/**
 * Common spacing values (in MUI theme spacing units)
 */
export const SPACING = {
  /** Extra small padding/margin */
  xs: 0.5,
  /** Small padding/margin */
  sm: 1,
  /** Medium padding/margin (default) */
  md: 2,
  /** Large padding/margin */
  lg: 3,
  /** Extra large padding/margin */
  xl: 4,
} as const;

/**
 * Common border radius values
 */
export const BORDER_RADIUS = {
  /** No rounding */
  none: 0,
  /** Slight rounding */
  sm: 1,
  /** Default rounding */
  md: 2,
  /** More pronounced rounding */
  lg: 3,
  /** Fully rounded (for pills/chips) */
  full: 9999,
} as const;

/**
 * Common animation durations (in ms)
 */
export const ANIMATION_DURATION = {
  fast: 150,
  normal: 300,
  slow: 500,
} as const;

/**
 * Z-index values for layering
 */
export const Z_INDEX = {
  drawer: 1200,
  modal: 1300,
  popover: 1400,
  tooltip: 1500,
  toast: 1600,
} as const;

/**
 * Safe area CSS values for mobile devices
 */
export const SAFE_AREA = {
  /** Padding for bottom navigation/home indicator */
  bottomPadding: 'calc(16px + env(safe-area-inset-bottom))',
  /** Padding for top notch area */
  topPadding: 'calc(16px + env(safe-area-inset-top))',
} as const;
